// OSIS - Măsurători la Clienți
import React, { useState } from 'react';
import { 
  Ruler,
  Calendar,
  MapPin,
  Clock,
  User,
  Phone,
  CheckCircle,
  AlertTriangle,
  Plus,
  Eye,
  Edit3,
  Navigation,
  Camera,
  FileText,
  Filter
} from 'lucide-react';
import Card from '../../components/Card';

const ClientMeasurements = () => {
  const [selectedView, setSelectedView] = useState('calendar');
  const [selectedDate, setSelectedDate] = useState(new Date().toISOString().split('T')[0]);

  // Măsurători programate
  const scheduledMeasurements = [
    {
      id: 'MSRT-2024-041',
      date: '2024-09-06',
      time: '09:00',
      duration: '1.5h',
      client: {
        name: 'Familia Popescu',
        contact: 'Elena Popescu',
        phone: '+40 754 123 456',
        email: 'elena.popescu@gmail.com'
      },
      location: {
        address: 'Str. Libertății nr. 45, București, Sector 2',
        coordinates: '44.4268, 26.1025',
        access: 'Apartament et. 3, interfon 15'
      },
      project: {
        type: 'proiecte living + bucătărie',
        description: '3 proiecte epoxidic pardoseală pentru renovare apartament',
        estimatedValue: '4,500 RON',
        complexity: 'Standard'
      },
      status: 'Confirmat',
      technician: 'Ionel Filip',
      notes: 'Client disponibil între 09:00-12:00. Parcare în curtea blocului.',
      requirements: ['Măsurătorí precizie', 'Fotografii pentru CAD', 'Verificare rezistență pereți'],
      priority: 'Medie'
    },
    {
      id: 'MSRT-2024-042',
      date: '2024-09-06',
      time: '14:30',
      duration: '2h',
      client: {
        name: 'SC Modern Build SRL',
        contact: 'Ing. Marian Gheorghe',
        phone: '+40 743 987 654',
        email: 'marian.gheorghe@modernbuild.ro'
      },
      location: {
        address: 'Șos. Colentina nr. 120, București, Sector 2',
        coordinates: '44.4685, 26.1355',
        access: 'Clădire birouri, et. 7, compania Modern Build'
      },
      project: {
        type: 'Sistem fațadă continua',
        description: 'Măsurători pentru înlocuire fațadă 15 etaje - 450m²',
        estimatedValue: '75,000 RON',
        complexity: 'Complexă'
      },
      status: 'De confirmat',
      technician: 'Ionel Filip',
      notes: 'Proiect major - necesară echipă suplimentară pentru măsurători. Acces cu autorizație.',
      requirements: ['Echipament măsurare cu laser', 'Analiză termică', 'Calcule structurale', 'Planuri arhitectură existentă'],
      priority: 'Ridicată'
    },
    {
      id: 'MSRT-2024-043',
      date: '2024-09-07',
      time: '10:15',
      duration: '1h',
      client: {
        name: 'Casa Verde SRL',
        contact: 'Arh. Diana Munteanu',
        phone: '+40 722 445 667',
        email: 'diana@casaverde.ro'
      },
      location: {
        address: 'Str. Parcului nr. 12, Voluntari, Ilfov',
        coordinates: '44.4956, 26.1754',
        access: 'Casă individuală, curte, sonerie principală'
      },
      project: {
        type: 'lucrări interior + exterior',
        description: 'Casa nouă - 8 lucrări interior lemn + 2 lucrări exterior blindate',
        estimatedValue: '12,000 RON',
        complexity: 'Standard'
      },
      status: 'Confirmat',
      technician: 'Ionel Filip',
      notes: 'Casă în construcție, finisaje la 80%. Arhitecta va fi prezentă.',
      requirements: ['Măsurători finale după tencuială', 'Coordonare cu arhitecta', 'Planuri execuție'],
      priority: 'Medie'
    },
    {
      id: 'MSRT-2024-044',
      date: '2024-09-08',
      time: '08:30',
      duration: '1h',
      client: {
        name: 'Familia Ionescu',
        contact: 'Mihai Ionescu',
        phone: '+40 766 334 221',
        email: 'mihai.ionescu@email.com'
      },
      location: {
        address: 'Bd. Unirii nr. 78, București, Sector 3',
        coordinates: '44.4267, 26.1138',
        access: 'Apartament et. 2, interfon 24'
      },
      project: {
        type: 'proiecte pardoseală',
        description: 'Înlocuire 5 proiecte vechi cu pardoseală eficient energetic',
        estimatedValue: '6,200 RON',
        complexity: 'Standard'
      },
      status: 'Reprogramat',
      technician: 'Ionel Filip',
      notes: 'REPROGRAMAT din 2024-09-05 la cererea clientului. Problema în familie.',
      requirements: ['Măsurători rapide', 'Consultanță eficiență energetică'],
      priority: 'Scăzută'
    },
    {
      id: 'MSRT-2024-045',
      date: '2024-09-09',
      time: '11:00',
      duration: '0.5h',
      client: {
        name: 'Restaurant Terasa Elite',
        contact: 'Chef Andrei Popov',
        phone: '+40 731 556 789',
        email: 'andrei@terasa-elite.ro'
      },
      location: {
        address: 'Str. Franceza nr. 45, București, Sector 1',
        coordinates: '44.4378, 26.0875',
        access: 'Restaurant, etaj 2, terasa'
      },
      project: {
        type: 'proiecte culisante terasa',
        description: 'Sistem proiecte mobile pentru închidere parțială terasă - 20m²',
        estimatedValue: '18,000 RON',
        complexity: 'Complexă'
      },
      status: 'Confirmat',
      technician: 'Ionel Filip',
      notes: 'Măsurători pe terasă activă. Programare în afara orelor de vârf (11:00-14:00).',
      requirements: ['Măsurători vânt și expunere', 'Sistem automatizare', 'Calculare greutate'],
      priority: 'Ridicată'
    }
  ];

  // Statistici măsurători
  const stats = [
    {
      title: 'Măsurători Programate',
      value: '15',
      change: '5 în următoarele 3 zile',
      changeType: 'warning',
      icon: Calendar,
      color: 'primary'
    },
    {
      title: 'Finalizate Săptămâna',
      value: '8',
      change: '+2 față de săptămâna trecută',
      changeType: 'positive',
      icon: CheckCircle,
      color: 'success'
    },
    {
      title: 'Valoare Estimată',
      value: '116,200 RON',
      change: 'Din măsurători programate',
      changeType: 'neutral',
      icon: FileText,
      color: 'secondary'
    },
    {
      title: 'Ionel - Program',
      value: '95%',
      change: 'Capacitate săptămâna aceasta',
      changeType: 'warning',
      icon: User,
      color: 'warning'
    }
  ];

  const getStatusColor = (status) => {
    switch(status) {
      case 'Confirmat': return 'success';
      case 'De confirmat': return 'warning';
      case 'Reprogramat': return 'error';
      case 'Anulat': return 'gray';
      default: return 'gray';
    }
  };

  const getPriorityColor = (priority) => {
    switch(priority) {
      case 'Ridicată': return 'error';
      case 'Medie': return 'warning';
      case 'Scăzută': return 'success';
      default: return 'gray';
    }
  };

  const getComplexityIcon = (complexity) => {
    switch(complexity) {
      case 'Complexă': return '🔥';
      case 'Standard': return '📐';
      default: return '📋';
    }
  };

  const formatTime = (time) => {
    return time.replace(':', ':');
  };

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between">
        <div>
          <h1 className="text-2xl sm:text-3xl font-bold text-gray-900 dark:text-white flex items-center">
            <Ruler className="w-8 h-8 mr-3 text-primary-600" />
            Măsurători la Clienți
          </h1>
          <p className="text-gray-600 dark:text-gray-400 mt-1">
            Programări și vizite tehnice - <span className="font-medium text-primary-600">Ionel Filip</span> • 
            {' '}{new Date().toLocaleDateString('ro-RO', { 
              weekday: 'long', 
              year: 'numeric', 
              month: 'long', 
              day: 'numeric' 
            })}
          </p>
        </div>
        
        <div className="mt-4 sm:mt-0 flex items-center space-x-3">
          <div className="flex bg-gray-100 dark:bg-gray-800 rounded-lg p-1">
            <button 
              onClick={() => setSelectedView('calendar')}
              className={`px-3 py-2 text-sm font-medium rounded-md transition-colors ${
                selectedView === 'calendar' 
                  ? 'bg-primary-500 text-white' 
                  : 'text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white'
              }`}
            >
              <Calendar className="w-4 h-4 mr-1 inline" />
              Calendar
            </button>
            <button 
              onClick={() => setSelectedView('list')}
              className={`px-3 py-2 text-sm font-medium rounded-md transition-colors ${
                selectedView === 'list' 
                  ? 'bg-primary-500 text-white' 
                  : 'text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white'
              }`}
            >
              <FileText className="w-4 h-4 mr-1 inline" />
              Lista
            </button>
          </div>
          
          <button className="btn btn-primary flex items-center">
            <Plus className="w-4 h-4 mr-2" />
            Programare Nouă
          </button>
        </div>
      </div>

      {/* Stats Cards */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {stats.map((stat, index) => {
          const Icon = stat.icon;
          return (
            <Card key={index} className="relative overflow-hidden">
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-sm font-medium text-gray-600 dark:text-gray-400">{stat.title}</p>
                  <p className="text-2xl font-bold text-gray-900 dark:text-white mt-2">{stat.value}</p>
                  <p className={`text-sm mt-1 ${
                    stat.changeType === 'positive' ? 'text-success' :
                    stat.changeType === 'negative' ? 'text-error' : 
                    stat.changeType === 'warning' ? 'text-warning' :
                    'text-gray-500 dark:text-gray-400'
                  }`}>
                    {stat.change}
                  </p>
                </div>
                <div className={`p-3 rounded-xl bg-${stat.color}-100 dark:bg-${stat.color}-900/30`}>
                  <Icon className={`w-6 h-6 text-${stat.color}-600 dark:text-${stat.color}-400`} />
                </div>
              </div>
            </Card>
          );
        })}
      </div>

      {/* Main Content */}
      <div className="grid grid-cols-1 xl:grid-cols-4 gap-6">
        {/* Measurements List - 3 columns */}
        <div className="xl:col-span-3">
          <Card>
            <div className="flex items-center justify-between mb-6">
              <h3 className="text-lg font-semibold text-gray-900 dark:text-white flex items-center">
                <Calendar className="w-5 h-5 mr-2 text-primary-600" />
                Măsurători Programate ({scheduledMeasurements.length})
              </h3>
              <div className="flex items-center space-x-2">
                <button className="btn btn-sm btn-secondary">
                  <Filter className="w-4 h-4 mr-1" />
                  Filtrare
                </button>
                <input
                  type="date"
                  value={selectedDate}
                  onChange={(e) => setSelectedDate(e.target.value)}
                  className="form-input text-sm"
                />
              </div>
            </div>
            
            <div className="space-y-4 max-h-96 overflow-y-auto">
              {scheduledMeasurements.map((measurement, index) => (
                <div key={index} className="p-4 bg-gray-50 dark:bg-gray-800 rounded-xl hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors">
                  {/* Header */}
                  <div className="flex items-start justify-between mb-3">
                    <div className="flex-1">
                      <div className="flex items-center gap-2 mb-1">
                        <span className="font-medium text-gray-900 dark:text-white">{measurement.id}</span>
                        <span className="text-xs">{getComplexityIcon(measurement.project.complexity)}</span>
                        <span className={`px-2 py-1 text-xs font-medium rounded-full bg-${getPriorityColor(measurement.priority)}-100 text-${getPriorityColor(measurement.priority)}-700 dark:bg-${getPriorityColor(measurement.priority)}-900/30 dark:text-${getPriorityColor(measurement.priority)}-300`}>
                          {measurement.priority}
                        </span>
                        <span className={`px-2 py-1 text-xs font-medium rounded-full bg-${getStatusColor(measurement.status)}-100 text-${getStatusColor(measurement.status)}-700 dark:bg-${getStatusColor(measurement.status)}-900/30 dark:text-${getStatusColor(measurement.status)}-300`}>
                          {measurement.status}
                        </span>
                      </div>
                      <h4 className="text-sm font-semibold text-gray-900 dark:text-white mb-1">{measurement.project.type}</h4>
                      <p className="text-xs text-gray-600 dark:text-gray-400">{measurement.project.description}</p>
                    </div>
                    <div className="text-right">
                      <div className="flex items-center text-sm font-medium text-gray-900 dark:text-white mb-1">
                        <Clock className="w-4 h-4 mr-1 text-primary-600" />
                        {new Date(measurement.date).toLocaleDateString('ro-RO', { month: 'short', day: 'numeric' })} - {formatTime(measurement.time)}
                      </div>
                      <p className="text-xs text-gray-500 dark:text-gray-500">Durată: {measurement.duration}</p>
                    </div>
                  </div>

                  {/* Client Info */}
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-3 mb-3 p-3 bg-white dark:bg-gray-900 rounded-lg">
                    <div>
                      <div className="flex items-center text-sm text-gray-900 dark:text-white font-medium mb-1">
                        <User className="w-4 h-4 mr-1 text-secondary-600" />
                        {measurement.client.name}
                      </div>
                      <div className="flex items-center text-xs text-gray-600 dark:text-gray-400 mb-1">
                        <Phone className="w-3 h-3 mr-1" />
                        {measurement.client.phone}
                      </div>
                      <div className="text-xs text-gray-500">Contact: {measurement.client.contact}</div>
                    </div>
                    <div>
                      <div className="flex items-start text-xs text-gray-600 dark:text-gray-400 mb-1">
                        <MapPin className="w-3 h-3 mr-1 mt-0.5 flex-shrink-0" />
                        <span>{measurement.location.address}</span>
                      </div>
                      <div className="text-xs text-gray-500">{measurement.location.access}</div>
                    </div>
                  </div>

                  {/* Project Details */}
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-3 mb-3 text-xs">
                    <div>
                      <span className="font-medium text-gray-900 dark:text-white">Valoare estimată:</span>
                      <span className="text-success font-medium ml-1">{measurement.project.estimatedValue}</span>
                    </div>
                    <div>
                      <span className="font-medium text-gray-900 dark:text-white">Tehnician:</span>
                      <span className="text-primary-600 ml-1">{measurement.technician}</span>
                    </div>
                  </div>

                  {/* Requirements */}
                  <div className="mb-3">
                    <p className="text-xs font-medium text-gray-900 dark:text-white mb-1">Cerințe tehnice:</p>
                    <div className="flex flex-wrap gap-1">
                      {measurement.requirements.map((req, reqIndex) => (
                        <span key={reqIndex} className="px-2 py-1 text-xs bg-info-100 dark:bg-info-900/30 text-info-700 dark:text-info-300 rounded-full">
                          {req}
                        </span>
                      ))}
                    </div>
                  </div>

                  {/* Notes */}
                  {measurement.notes && (
                    <div className="mb-3 p-2 bg-yellow-50 dark:bg-yellow-900/20 rounded-lg">
                      <p className="text-xs text-gray-700 dark:text-gray-300">
                        <span className="font-medium">Note:</span> {measurement.notes}
                      </p>
                    </div>
                  )}

                  {/* Actions */}
                  <div className="flex items-center justify-end space-x-2">
                    <button className="btn btn-sm btn-secondary">
                      <Navigation className="w-3 h-3 mr-1" />
                      Navigație
                    </button>
                    <button className="btn btn-sm btn-info">
                      <Eye className="w-3 h-3 mr-1" />
                      Detalii
                    </button>
                    <button className="btn btn-sm btn-primary">
                      <Edit3 className="w-3 h-3 mr-1" />
                      Editează
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </Card>
        </div>

        {/* Quick Actions Sidebar */}
        <div className="space-y-6">
          <Card>
            <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-4 flex items-center">
              <Camera className="w-5 h-5 mr-2 text-secondary-600" />
              Acțiuni Rapide
            </h3>
            
            <div className="space-y-3">
              <button className="w-full p-3 text-left bg-primary-50 hover:bg-primary-100 dark:bg-primary-900/30 dark:hover:bg-primary-900/50 rounded-xl transition-colors">
                <Plus className="w-5 h-5 text-primary-600 mb-1" />
                <h4 className="font-medium text-gray-900 dark:text-white text-sm">Măsurătoare Urgentă</h4>
                <p className="text-xs text-gray-600 dark:text-gray-400">Programare în aceeași zi</p>
              </button>
              
              <button className="w-full p-3 text-left bg-secondary-50 hover:bg-secondary-100 dark:bg-secondary-900/30 dark:hover:bg-secondary-900/50 rounded-xl transition-colors">
                <Navigation className="w-5 h-5 text-secondary-600 mb-1" />
                <h4 className="font-medium text-gray-900 dark:text-white text-sm">Optimizare Rută</h4>
                <p className="text-xs text-gray-600 dark:text-gray-400">Calculare traseu eficient</p>
              </button>
              
              <button className="w-full p-3 text-left bg-info-50 hover:bg-info-100 dark:bg-info-900/30 dark:hover:bg-info-900/50 rounded-xl transition-colors">
                <Camera className="w-5 h-5 text-info-600 mb-1" />
                <h4 className="font-medium text-gray-900 dark:text-white text-sm">Upload Fotografii</h4>
                <p className="text-xs text-gray-600 dark:text-gray-400">Documentare măsurători</p>
              </button>
              
              <button className="w-full p-3 text-left bg-success-50 hover:bg-success-100 dark:bg-success-900/30 dark:hover:bg-success-900/50 rounded-xl transition-colors">
                <CheckCircle className="w-5 h-5 text-success-600 mb-1" />
                <h4 className="font-medium text-gray-900 dark:text-white text-sm">Finalizare Măsurători</h4>
                <p className="text-xs text-gray-600 dark:text-gray-400">Marcare completare</p>
              </button>
            </div>
          </Card>

          {/* Today's Summary */}
          <Card>
            <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-4 flex items-center">
              <Clock className="w-5 h-5 mr-2 text-warning-600" />
              Programul de Azi
            </h3>
            
            <div className="space-y-3">
              <div className="p-3 bg-warning-50 dark:bg-warning-900/20 rounded-lg">
                <div className="flex items-center justify-between mb-1">
                  <span className="text-sm font-medium text-gray-900 dark:text-white">09:00</span>
                  <span className="px-2 py-1 text-xs bg-success-100 text-success-700 rounded-full">Confirmat</span>
                </div>
                <p className="text-sm text-gray-700 dark:text-gray-300">Familia Popescu</p>
                <p className="text-xs text-gray-600 dark:text-gray-400">proiecte living + bucătărie</p>
              </div>
              
              <div className="p-3 bg-warning-50 dark:bg-warning-900/20 rounded-lg">
                <div className="flex items-center justify-between mb-1">
                  <span className="text-sm font-medium text-gray-900 dark:text-white">14:30</span>
                  <span className="px-2 py-1 text-xs bg-warning-100 text-warning-700 rounded-full">De confirmat</span>
                </div>
                <p className="text-sm text-gray-700 dark:text-gray-300">SC Modern Build</p>
                <p className="text-xs text-gray-600 dark:text-gray-400">Sistem fațadă continua</p>
              </div>
            </div>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default ClientMeasurements;